import React, { useContext } from 'react';
import './signup.css';
import { useTranslation } from 'react-i18next';
import DataContext from '../../context/Datacontext';
import useWindowSize from '../../hooks/useWindowSize';
import Way_go_logo from '../../images/way_go_bepartner.svg'

// import io from 'socket.io-client';
const SignUp = () => {
    // const socket = io.connect("https://way-go.vercel.app/");
    const {lang} = useContext(DataContext);
    const [t] = useTranslation("global");
    const {width} = useWindowSize();
    const{firstName,lastName,fatherName,motherName,phoneNumber,gender,iss,
        setFirstName,setLastName,setFatherName,setMotherName,setPhoneNumber,setGender,setIss,singup} = useContext(DataContext);
  
  return (
    <div className='signup_main' style={{
            // justifyContent:lang ? width > 600 ? 'flex-end' : 'center' : width > 600 ? 'flex-end' :  'center',
            flexDirection:lang ? width > 1000 ? 'row' : 'column' : width > 1000 ? 'row-reverse' :  'column',
            paddingTop:"100px",paddingBottom:"100px"
            }}>
        <div className='signup_container_box'
             style={{
                // marginLeft:!lang && width > 1000 ? '50px' : '0px',marginRight:lang && width > 1000 ? '70px' : '0px',
                    //  marginTop:width<1000 ?'50px':'0px',
                     flexDirection:width<425?'column':'row',
                     marginLeft:width > 1000 && !lang?'0px':'50px',marginRight:width > 1000 && lang?'0px':'50px',
             }}
        >
            <div className='signup_box_1'>
                <img src={Way_go_logo} alt='' style={{width:width<=1000 ? "80%" : "100%"}}/>
            </div>
        </div>
        <div className='signup_container' 
             style={{marginLeft:width > 600 && !lang?'100px':'0px',marginRight:width > 600 && lang?'100px':'0px',
                     justifyContent:lang?'flex-end':'flex-start',marginTop:width<1000 ? '45px':'0px'}}>
            <div className='signup_h1' style={{alignItems:lang?'flex-end':'flex-start'}}>
                <p className='signup_para'>{t("signup.sign")}</p>
            </div>
            <div className='signup_h2' style={{alignItems:lang?'flex-end':'flex-start',marginTop:'10px',marginBottom:'10px'}}>
                <p className='signup_para'>{t("signup.onour")}</p>
                <p className='signup_para'>{t("signup.onour1")}</p>
            </div>
            <form onSubmit={singup}>
                <div className='signup_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='signup_para'>{t("signup.first")}</p>
                    <input className='signupInput' type='text' required onChange={(e) => setFirstName(e.target.value)} value={firstName}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='signup_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='signup_para'>{t("signup.last")}</p>
                    <input className='signupInput' type='text' required onChange={(e) => setLastName(e.target.value)} value={lastName}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='signup_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='signup_para'>{t("signup.father")}</p>
                    <input className='signupInput' type='text' required onChange={(e) => setFatherName(e.target.value)} value={fatherName} 
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='signup_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='signup_para'>{t("signup.mother")}</p>
                    <input className='signupInput' type='text' required onChange={(e) => setMotherName(e.target.value)} value={motherName}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='signup_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='signup_para'>{t("signup.phone")}</p>
                    <input className='signupInput' maxLength={10} minLength={10} type='text' required onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='signup_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='signup_para'>{t("signup.gender")}</p>
                    <input className='signupInput' type='text' required onChange={(e) => setGender(e.target.value)} value={gender} 
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>

                <div className='signup_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='signup_para'>{t("signup.iss")}</p>
                    <input className='signupInput' type='text' maxLength={11} minLength={11} required onChange={(e) => setIss(e.target.value)} value={iss} 
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='signup_h3' style={{justifyContent:lang?'flex-end':'flex-start'}}>
                    <button type='submit' className='signup_sign'>{t("signup.sign")}</button>
                </div>
            </form>
        </div>
    </div>
  )
}

export default SignUp